import React, { useContext } from "react";
import { PoseLandmarker } from "@mediapipe/tasks-vision";
import { ProcedureType, TScreen } from "api/type";

// Import Contexts
import { ClinicContext, ScreenContext } from "contexts";

// Import Components
import { TitleBar, Scan } from "components/index";
import { mixpanelTrack } from "utils/mixpanel";
import { TImageBlobAndViewType } from "components/scan/Scan";

type ScreenScanProps = {
  selectedProcedure: ProcedureType | null;
  poseLandmarker: PoseLandmarker | "ERROR" | null;
  handleSaveImageUrlOrBlob: (imageUrlOrBlob: Blob | string) => void;
};

const ScreenScan: React.FC<ScreenScanProps> = ({
  selectedProcedure,
  poseLandmarker,
  handleSaveImageUrlOrBlob,
}) => {
  // Context
  const clinic = useContext(ClinicContext);
  const setScreen = useContext(ScreenContext)[1];

  React.useEffect(() => {
    if (!clinic) return;
    mixpanelTrack("Photo Capture Started", [
      {
        propertyName: "Clinic Name",
        propertyValue: clinic.clinic_name ?? "failed to get clinic name",
      },
    ]);
  }, [clinic]);

  const handleSaveImageBlobsAndViewTypes = (
    imageBlobsAndViewTypes: TImageBlobAndViewType[],
  ) => {
    if (imageBlobsAndViewTypes.length !== 0) {
      const firstImageBlob = imageBlobsAndViewTypes[0].image;
      handleSaveImageUrlOrBlob(firstImageBlob);
      setScreen(TScreen.SIMULATION_VIEW_SCREEN);

      mixpanelTrack("Photo Capture Finished", [
        {
          propertyName: "Clinic Name",
          propertyValue: clinic?.clinic_name ?? "failed to get clinic name",
        },
      ]);
    }
  };

  return (
    <div className="screen-container">
      <TitleBar
        name={"Scan"}
        onClickBackButton={() =>
          setScreen(TScreen.BODY_SCAN_INSTRUCTIONS_SCREEN)
        }
      />
      <Scan
        poseLandmarker={poseLandmarker}
        selectedProcedure={selectedProcedure}
        handleSaveImageBlobsAndViewTypes={handleSaveImageBlobsAndViewTypes}
      />
    </div>
  );
};

export default ScreenScan;
